/**
 * Labstep
 */

import {
  dateOnlyAtUTC,
  timeOnlyAtUTC,
} from 'labstep-web/services/date.service';
import { PostFilter } from 'labstep-web/services/postFilter';
import type { PostFilterComparisonType } from 'labstep-web/services/postFilter/constants';
import {
  PostFilterComparison,
  PostFilterComparisonHumanReadableShort,
  type PostFilterNodeType,
} from 'labstep-web/services/postFilter/constants';

export class PostFilterMetadatas extends PostFilter<
  'label' | 'value' | 'number' | 'date' | 'options' | 'inchis',
  string
> {
  /**
   * Get the human readable string for a metadata filter
   * @param node Post filter node
   * @param comparisionLabel Optional comparator label to override the default
   * @returns Human readable string
   */
  public getHumanReadableString(
    node: PostFilterNodeType,
    comparisionLabel?: string,
  ): string | null {
    const attributeValues = this.getAttributeValues(node);
    const { label, value, number, date, options, inchis } =
      attributeValues;

    if (inchis) {
      return `Chemical Structure`;
    }

    if (!label) {
      return null;
    } // if attributeValues is empty

    const metadataLabel = label.value;
    let metadataComparison: PostFilterComparisonType =
      PostFilterComparison.eq;
    let metadataValue: string | undefined;
    if (value) {
      metadataValue = value.value;
      metadataComparison = value.comparison;
    } else if (number) {
      metadataValue = number.value;
      metadataComparison = number.comparison;
    } else if (date) {
      const jsDate = new Date(date.value);
      const isDateOnly =
        jsDate.getUTCHours() === 0 &&
        jsDate.getUTCMinutes() === 0 &&
        jsDate.getUTCSeconds() === 0 &&
        jsDate.getUTCMilliseconds() === 0;

      if (isDateOnly) {
        metadataValue = dateOnlyAtUTC(date.value);
      } else {
        const datePart = dateOnlyAtUTC(date.value);
        const timePart = timeOnlyAtUTC(date.value);
        metadataValue = `${datePart} ${timePart}`;
      }
    } else if (options) {
      metadataValue = options.value;
      metadataComparison = options.comparison;
    }
    if (comparisionLabel) {
      return `${metadataLabel} ${comparisionLabel} ${metadataValue}`;
    }
    return `${metadataLabel} ${PostFilterComparisonHumanReadableShort[metadataComparison as keyof typeof PostFilterComparisonHumanReadableShort]} ${metadataValue}`;
  }
}
